import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NavbarSidebarWrapper from "../../components/navbarSidebarWrapper";
import ScreenLoader from "../../components/ScreenLoader";
import actions from "../../redux/actions";
import moment from "moment";
import { notifyError, notifySuccess } from "../../components/ToastContext";

const MatchTable = ({
  matchList,
  actionLabel,
  onAction,
  onViewBook,
  actionClass,
}) => {
  return (
    <table
      className="table table-bordered table-striped"
      width="100%"
      cellSpacing="0"
    >
      <thead>
        <tr>
          <th>#</th>
          <th>Match Name</th>
          <th>Match Type</th>
          <th>Match Date</th>
          <th>InPlay</th>
          <th>Status</th>
          <th>Toss</th>
          <th>Result</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {matchList.length > 0 ? (
          matchList.map((item, index) => {
            let teams = [];
            try {
              teams = JSON.parse(item.TeamInfo || "[]");
            } catch (e) {
              teams = [];
            }
            return (
              <tr key={item.Id}>
                <td>{index + 1}</td>
                <td>
                  {item.MatchName}
                  {teams.length > 0 && (
                    <div className="small text-muted">
                      {teams.map((t) => t.teamSName).join(" vs ")}
                    </div>
                  )}
                </td>
                <td>{item.MatchType}</td>
                <td>{moment(item.MatchDate).format("DD-MM-YYYY hh:mm A")}</td>
                <td>
                  <span
                    className={`badge ${item.InPlay ? "badge-success" : "badge-secondary"}`}
                  >
                    {item.InPlay ? "Yes" : "No"}
                  </span>
                </td>
                <td>{item.Status}</td>
                <td>{item.Toss || "-"}</td>
                <td>{item.Result || "-"}</td>
                <td>
                  {onViewBook && (
                    <button
                      className="btn btn-sm btn-primary mr-1"
                      onClick={() => onViewBook(item.MatchId)}
                    >
                      View Book
                    </button>
                  )}
                  <button
                    className={`btn btn-sm ${actionClass}`}
                    onClick={() => onAction(item.MatchId)}
                  >
                    {actionLabel}
                  </button>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="9" className="text-center">
              No matches found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

const FantasyLiveMatch = () => {
  const liveData = useSelector((state) => state.fantacyMatch?.liveMatchList);
  const compliteData = useSelector(
    (state) => state.fantacyMatch?.compliteMatchList,
  );
  const [loader, setLoader] = useState(true);
  const [activeTab, setActiveTab] = useState("inplay");
  const navigate = useNavigate();

  const fetchLiveMatches = async () => {
    setLoader(true);
    try {
      let res = await actions.getLiveMatchList();
      if (res?.data?.Status === false) {
        notifyError(res?.data?.Result || "Failed to load live matches");
      }
    } catch (err) {
      notifyError(err?.response?.data?.Result || "Failed to load live matches");
    }
    setLoader(false);
  };

  const fetchCompliteMatches = async () => {
    setLoader(true);
    try {
      let res = await actions.getCompliteMatchList();
      if (res?.data?.Status === false) {
        notifyError(res?.data?.Result || "Failed to load completed matches");
      }
    } catch (err) {
      notifyError(
        err?.response?.data?.Result || "Failed to load completed matches",
      );
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchLiveMatches();
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "inplay") {
      fetchLiveMatches();
    } else {
      fetchCompliteMatches();
    }
  };

  const handleViewBook = (matchId) => {
    navigate(`/fantasy-joined-users/${matchId}`);
  };

  const handleTransfer = async (matchId) => {
    if (
      !window.confirm(
        `Are you sure you want to transfer result for Match ID: ${matchId}?`,
      )
    )
      return;
    setLoader(true);
    try {
      let res = await actions.setFnResult(matchId);
      if (res?.data?.Status === false) {
        notifyError(res?.data?.Result || "Transfer failed");
        setLoader(false);
      } else {
        notifySuccess(res?.data?.Result || "Transfer successful");
        fetchLiveMatches();
      }
    } catch (err) {
      notifyError(err?.response?.data?.Result || "Transfer failed");
      setLoader(false);
    }
  };

  const handleReverseCoin = async (matchId) => {
    if (
      !window.confirm(
        `Are you sure you want to reverse coins for Match ID: ${matchId}?`,
      )
    )
      return;
    setLoader(true);
    try {
      let res = await actions.setFnResultRollback(matchId);
      if (res?.data?.Status === false) {
        notifyError(res?.data?.Result || "Rollback failed");
        setLoader(false);
      } else {
        notifySuccess(res?.data?.Result || "Rollback successful");
        fetchCompliteMatches();
      }
    } catch (err) {
      notifyError(err?.response?.data?.Result || "Rollback failed");
      setLoader(false);
    }
  };

  const liveMatchList = liveData?.Result || [];
  const compliteMatchList = compliteData?.Result || [];

  return (
    <NavbarSidebarWrapper>
      <div className="content-header-btn mb-2">Fantasy Live Match Book</div>
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "inplay" ? "active" : ""}`}
            href="#inplay"
            data-toggle="tab"
            onClick={() => handleTabChange("inplay")}
          >
            In-Play
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "completed" ? "active" : ""}`}
            href="#completed"
            data-toggle="tab"
            onClick={() => handleTabChange("completed")}
          >
            Completed
          </a>
        </li>
      </ul>
      {loader ? (
        <ScreenLoader />
      ) : (
        <div className="tab-content">
          <div
            className={`tab-pane fade ${activeTab === "inplay" ? "show active" : ""}`}
            id="inplay"
          >
            <div className="card shadow mb-4">
              <div className="table-responsive">
                <div className="dataTables_wrapper dt-bootstrap4">
                  <MatchTable
                    matchList={liveMatchList}
                    actionLabel="Transfer"
                    actionClass="btn-warning"
                    onAction={handleTransfer}
                    onViewBook={handleViewBook}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={`tab-pane fade ${activeTab === "completed" ? "show active" : ""}`}
            id="completed"
          >
            <div className="card shadow mb-4">
              <div className="table-responsive">
                <div className="dataTables_wrapper dt-bootstrap4">
                  <MatchTable
                    matchList={compliteMatchList}
                    actionLabel="Reverse Coin"
                    actionClass="btn-danger"
                    onAction={handleReverseCoin}
                    onViewBook={handleViewBook}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </NavbarSidebarWrapper>
  );
};

export default FantasyLiveMatch;
